import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { M_Table, NavigateContext } from 'src/M_Components'

export const ChargeRulesList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const ctx2 = useContext(NavigateContext)

    const openCrud = (operation, row) => {

        ctx2.newTab('go/chargeRulesCrud', t(`ChargeRules${operation}`))
    }

    return (
        <M_Table
            entityName={'ChargeRule'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'Charge Rules'}
            removeContextItems={['Print']}
            replaceFunctions={new Map([
                ['Create', () => openCrud('Create')],
                ['Edit', (e) => openCrud('Edit', e)],
                ['Copy', (e) => openCrud('Copy', e)],
                ['View', (e) => openCrud('View', e)]
            ])}
        />
    )
}
